import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';

export const Dashboard = props => (
    <Card>
        <CardHeader title="Welcome to the Navigo Dashboard" />
        <CardContent>Here you can check your Scores !!!</CardContent>
    </Card>
);